/* Contador de estoque da oferta -- "compre e ganhe".

   O NUMERO E DERIVADO DO TEMPO, nao decrementado por temporizador.

   A diferenca importa. Um `setInterval` que faz `n--` perde a conta se a aba
   dorme, se o navegador estrangula o temporizador em segundo plano, ou se a
   cliente troca de pagina -- e cada aba passa a ter o proprio numero. Aqui o
   valor e uma funcao do instante inicial: o cronograma de quedas e reconstruido
   por um sorteio SEMEADO pelo `t0`, e `valor()` so soma o que ja venceu. O
   temporizador apenas pergunta "que valor e agora"; a resposta e a mesma em
   qualquer aba, depois de qualquer soneca e depois de qualquer recarga -- mesmo
   com a queda sendo irregular e as vezes de 2 ou 3 de uma vez.

   O instante inicial vive em `sessionStorage` por produto. Fecha o navegador,
   comeca de novo -- que e o comportamento desejado: a urgencia e por visita.

   Chegando a zero o bloco sai do DOM visivel em vez de exibir "0 restantes"
   acima de um botao que continua vendendo. */
(function () {
  'use strict';

  var DUR_PASSO = 620;

  /* O PISO. Por pedido (04/09/2026) nem o total da oferta nem o numero por
     variante descem de 1: "restam 0" acima de um botao que continua vendendo e
     a pior leitura possivel, e "esgotado" mataria a pagina de anuncio.

     Com piso, o bloco nunca mais sai da tela -- o `hidden` em zero deixou de
     ser alcancavel e virou so uma rede para `data-inicio` mal preenchido. */
  var PISO = 1;
  /* A piscada dura mais que o deslize do odometro de proposito: ela precisa
     ainda estar acesa quando o numero novo assenta, senao o olho e atraido para
     um bloco que ja parou de mudar. */
  var DUR_PISCA = 1400; // casa com a animacao do anel no CSS

  function agora() {
    return Date.now();
  }

  /* O inicio da contagem, por produto e por sessao.

     `try/catch` porque sessionStorage estoura em aba privada de alguns
     navegadores e dentro de iframe com cookies bloqueados. Sem armazenamento o
     contador ainda funciona -- ele so recomeca a cada pagina, que e uma
     degradacao aceitavel e silenciosa. */
  function lerInicio(chave, total) {
    var t = null;
    try {
      var bruto = window.sessionStorage.getItem(chave);
      if (bruto) t = parseInt(bruto, 10);
    } catch (e) {}

    // Instante ausente, ilegivel ou tao antigo que a contagem ja acabou:
    // comeca agora. O "ja acabou" e o que impede uma sessao longa de nascer
    // com o bloco escondido em toda pagina nova.
    if (!t || isNaN(t) || agora() - t > total * 1000) {
      t = agora();
      try { window.sessionStorage.setItem(chave, String(t)); } catch (e) {}
    }
    return t;
  }

  function Contador(el) {
    this.el = el;
    this.inicio = parseInt(el.getAttribute('data-inicio'), 10) || 73;
    this.total = parseInt(el.getAttribute('data-segundos'), 10) || 900;
    // Largura da barra com estoque cheio. Ver o comentario em `pintar`.
    this.teto = parseFloat(el.getAttribute('data-teto'));
    if (isNaN(this.teto) || this.teto <= 0) this.teto = 100;
    this.chave = el.getAttribute('data-chave') || 'tp-eo';
    this.digitos = el.querySelector('[data-eo-digitos]');
    this.barra = el.querySelector('[data-eo-barra]');
    this.leitor = el.querySelector('[data-eo-leitor]');
    this.totalEl = el.querySelector('[data-eo-total]');
    this.relogio = el.querySelector('[data-eo-relogio]');
    this.colPrazo = el.querySelector('[data-eo-prazo]');
    /* O denominador exibido -- o "de 240" ao lado do numero.

       Ele NAO participa da mecanica: o contador continua saindo de
       `data-inicio` e o rateio por variante tambem. O total serve para dar
       escala ao numero, e a escala e o que transforma 73 em "quase acabou".
       Ver o comentario da escolha do valor no snippet. */
    this.total_lote = parseInt(el.getAttribute('data-total'), 10);
    if (isNaN(this.total_lote) || this.total_lote <= this.inicio) this.total_lote = 0;

    this.t0 = lerInicio(this.chave, this.total);
    /* Quantas unidades o cronograma pode remover. Nao e `inicio`: com piso de 1
       a contagem para em 1, entao ha `inicio - PISO` quedas a distribuir. Somar
       ate `inicio` faria a ultima queda ser engolida e o contador terminaria
       em 0 mesmo com piso. */
    this.removivel = Math.max(0, this.inicio - PISO);
    this.ultimo = null;
    this.fitas = [];
  }

  /* SORTEIO SEMEADO -- mulberry32.

     A queda precisa parecer irregular, com quedas de 2 e 3 de vez em quando, e
     ao mesmo tempo continuar sendo a MESMA em qualquer aba e depois de qualquer
     recarga. `Math.random()` daria a irregularidade e destruiria a segunda
     metade: cada recarga inventaria outra queda, e duas abas discordariam.

     A saida e um gerador deterministico semeado pelo instante inicial da
     sessao. Mesma semente, mesma sequencia -- entao o cronograma abaixo e
     reconstruido identico a cada render, sem precisar guardar nada alem do
     `t0` que ja estava no sessionStorage. E como a semente e o `t0`, cada
     visita sorteia um cronograma diferente. */
  function semear(s) {
    var a = s >>> 0;
    return function () {
      a = (a + 0x6d2b79f5) >>> 0;
      var t = a;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  /* O CRONOGRAMA: quanto cai, e quando.

     Passos de 1, 2 ou 3 com pesos 55/30/15 -- media ~1,6, o que da uns 45
     passos nos 900 segundos, um a cada ~20s. Passo maior e mais raro de
     proposito: se 3 fosse comum, o estoque despencaria em blocos e a conta
     ficaria obvia.

     O ULTIMO PASSO E APARADO para a soma fechar exatamente em `inicio`. Sem
     isso a sequencia passaria de 73 e o contador terminaria negativo, ou
     pararia antes do fim e a barra nunca zeraria no minuto 15.

     O TEMPO DE CADA PASSO nasce da divisao igual dos 900s e recebe um empurrao
     de ate 45% da propria fatia. E o empurrao que tira o compasso de metronomo,
     que e o que mais denuncia contador falso. `Math.max` com o anterior mantem
     a ordem: sem ele dois passos poderiam trocar de lugar e o numero subiria. */
  Contador.prototype.cronograma = function () {
    if (this._crono) return this._crono;

    var rnd = semear(this.t0);
    var passos = [];
    var soma = 0;
    while (soma < this.removivel) {
      var r = rnd();
      var tam = r < 0.55 ? 1 : (r < 0.85 ? 2 : 3);
      if (soma + tam > this.removivel) tam = this.removivel - soma;
      soma += tam;
      passos.push(tam);
    }
    if (!passos.length) { this._crono = []; return this._crono; }

    var fatia = this.total / passos.length;
    var crono = [];
    var anterior = 0;
    for (var i = 0; i < passos.length; i++) {
      var nominal = (i + 1) * fatia;
      var desvio = (rnd() - 0.5) * 0.9 * fatia;
      var quando = nominal + desvio;
      if (quando < anterior + 0.5) quando = anterior + 0.5;
      if (quando > this.total) quando = this.total;
      anterior = quando;
      crono.push({ t: quando, n: passos[i] });
    }

    this._crono = crono;
    return crono;
  };

  Contador.prototype.valor = function () {
    var decorrido = (agora() - this.t0) / 1000;
    if (decorrido <= 0) return this.inicio;
    if (decorrido >= this.total) return Math.max(PISO, Math.min(this.inicio, PISO));

    var crono = this.cronograma();
    var caiu = 0;
    for (var i = 0; i < crono.length; i++) {
      if (crono[i].t > decorrido) break;
      caiu += crono[i].n;
    }

    var restante = this.inicio - caiu;
    if (restante > this.inicio) restante = this.inicio;
    if (restante < PISO) restante = PISO;
    return restante;
  };

  /* Monta uma janela por digito, cada uma com a fita de 0 a 9 dentro.

     Remontar tudo a cada passo mataria a animacao -- a fita nova nasceria ja na
     posicao final. Entao a estrutura se monta UMA vez, e depois so o
     `transform` de cada fita muda. Ela e refeita apenas quando o numero perde
     uma casa (de 10 para 9), porque ai a caixa realmente mudou. */
  Contador.prototype.montar = function (n) {
    var txt = String(n);
    this.digitos.textContent = '';
    this.fitas = [];
    for (var i = 0; i < txt.length; i++) {
      var janela = document.createElement('span');
      janela.className = 'tp-eo__digito';
      var fita = document.createElement('span');
      fita.className = 'tp-eo__fita';
      for (var d = 0; d <= 9; d++) {
        var s = document.createElement('span');
        s.textContent = String(d);
        fita.appendChild(s);
      }
      janela.appendChild(fita);
      this.digitos.appendChild(janela);
      this.fitas.push(fita);
    }
    this.casas = txt.length;
  };

  Contador.prototype.posicionar = function (n, animar) {
    var txt = String(n);
    for (var i = 0; i < this.fitas.length; i++) {
      var d = parseInt(txt[i], 10);
      var fita = this.fitas[i];
      if (!animar) fita.style.transition = 'none';
      fita.style.transform = 'translateY(-' + d + 'em)';
      if (!animar) {
        // Forca o navegador a aplicar antes de devolver a transicao, senao o
        // salto sem animacao acabaria animado no primeiro passo seguinte.
        void fita.offsetHeight;
        fita.style.transition = '';
      }
    }
  };

  Contador.prototype.pintar = function (n, animar, queda) {
    if (this.casas !== String(n).length) this.montar(n);
    this.posicionar(n, animar);

    /* A BARRA TEM DOIS NUMEROS DIFERENTES, e confundi-los era o erro facil.

       `fracao` e quanto do estoque resta, de 1 a 0. `teto` e a largura da barra
       quando a fracao vale 1 -- hoje 33%, para a barra nascer com um terco e a
       trilha vazia dizer "ja acabou a maior parte" antes de o numero ser lido.

       O limiar do coral usa a FRACAO, nao a largura. Com a largura, o teto de
       33% cruzaria "25%" quase de imediato (em 55 unidades de 73) e o coral
       ficaria aceso em tres quartos da contagem -- deixaria de ser sinal e
       viraria a cor do bloco. Pela fracao ele acende no ultimo quarto de
       verdade, abaixo de 19 unidades, como antes de a barra mudar de escala. */
    var fracao = n / this.inicio;
    this.barra.style.width = (fracao * this.teto) + '%';
    this.el.classList.toggle('tp-eo--baixo', fracao <= 0.25);

    if (this.totalEl && this.total_lote) {
      this.totalEl.textContent = 'de ' + this.total_lote;
    }

    if (this.leitor) {
      this.leitor.textContent = n + (n === 1 ? ' unidade restante' : ' unidades restantes') +
        (this.total_lote ? ' de ' + this.total_lote : '');
    }

    /* AVISA QUEM DEPENDE DO NUMERO -- hoje o seletor de kit, que reescreve o
       "restam apenas X pecas" do passo aberto. O valor tambem fica gravado no
       proprio elemento, para quem chega depois do evento e precisa do estado
       atual sem esperar a proxima queda. */
    this.el.setAttribute('data-eo-valor', String(n));
    try {
      document.dispatchEvent(new CustomEvent('tp-eo:mudou', {
        detail: { valor: n, inicio: this.inicio, queda: queda || 0 }
      }));
    } catch (e) {}

    /* A PISCADA E PROPORCIONAL A QUEDA.

       Agora que o passo pode ser de 1, 2 ou 3, uma piscada de intensidade fixa
       desperdiça a informacao mais chamativa que o contador tem: cair tres de
       uma vez e o momento em que a cliente deveria olhar. `--forte` sai a
       partir de 2 -- borda mais grossa, coral e uma segunda batida.

       `remove` + leitura de `offsetWidth` + `add` reinicia a animacao. Sem
       forcar esse reflow no meio, o navegador agrupa as duas mudancas de classe
       na mesma pintura, conclui que nada mudou e a animacao nao roda de novo --
       a segunda queda seguida ficaria sem piscada. */
    if (animar) {
      var el = this.el;
      el.classList.remove('tp-eo--pulso', 'tp-eo--forte');
      void el.offsetWidth;
      el.classList.add('tp-eo--pulso');
      if (queda >= 2) el.classList.add('tp-eo--forte');
      window.setTimeout(function () {
        el.classList.remove('tp-eo--pulso', 'tp-eo--forte');
      }, DUR_PISCA);
    }
  };

  /* ===================================================================
     O RATEIO POR VARIANTE
     ===================================================================
     Pedido: ao escolher cor e tamanho, o passo diz "restam apenas X pecas", e a
     SOMA de todas as variantes disponiveis tem que dar exatamente o numero da
     oferta. Quem confere somando os tamanhos nao pode pegar contradicao.

     Isso exige tres propriedades ao mesmo tempo, e cada uma mata uma
     implementacao ingenua:

     1. SOMA EXATA. Rateio proporcional com arredondamento independente por
        variante nao fecha -- sobra ou falta 1. Aqui a sobra e distribuida por
        maior resto, que fecha por construcao.

     2. MONOTONIA. Nenhuma variante pode SUBIR quando o total desce. Recalcular
        o rateio a cada valor novo nao garante isso: no metodo de maior resto uma
        variante pode ganhar 1 enquanto outra perde 2, e a cliente que volta num
        tamanho ve o numero crescer -- o que denuncia tudo de uma vez. Entao o
        rateio e calculado UMA vez, no total cheio, e o que varia e quantas
        baixas ja foram aplicadas: uma FILA de remocao fixa, embaralhada na
        semente. Descer e sempre consumir mais um pedaco da mesma fila.

     3. PISO DE 1. Cada variante nasce com 1 unidade reservada, e a fila so
        contem as unidades ACIMA desse 1. Nenhuma remocao pode levar uma variante
        a zero -- nao por clamp depois, mas porque a baixa nao existe na fila.

     LIMITE ARITMETICO, dito sem enfeite: com V variantes a soma dos pisos ja
     vale V. Enquanto o total da oferta for >= V a soma e exata. Abaixo disso e
     impossivel manter "cada uma >= 1" e "soma = total" juntas -- as duas foram
     pedidas, e o piso vence, porque e ele que a cliente le. Na pratica isso e so
     o fim da contagem: com 73 caindo ate 1 em 900s e uma grade de ~12 variantes,
     a soma e exata em ~98% da descida. */
  function hashLista(ids) {
    var h = 2166136261;
    for (var i = 0; i < ids.length; i++) {
      var s = String(ids[i]);
      for (var k = 0; k < s.length; k++) {
        h ^= s.charCodeAt(k);
        h = Math.imul(h, 16777619);
      }
    }
    return h >>> 0;
  }

  Contador.prototype.rateio = function (ids) {
    var chave = hashLista(ids);
    if (!this._rateios) this._rateios = {};
    if (this._rateios[chave]) return this._rateios[chave];

    var V = ids.length;
    /* Semente misturada com o hash da grade: passos diferentes do mesmo kit
       (legging e top) recebem reparticoes diferentes. Com a semente crua os dois
       mostrariam o mesmo numero no mesmo tamanho, e a coincidencia apareceria na
       primeira conferida. */
    var rnd = semear((this.t0 ^ chave) >>> 0);

    var pesos = [], somaP = 0, i;
    for (i = 0; i < V; i++) { var w = 0.35 + rnd(); pesos.push(w); somaP += w; }

    var aloc = [];
    var sobra = this.inicio - V;
    if (sobra <= 0) {
      // Mais variantes que estoque: todas no piso. Ver o limite aritmetico.
      for (i = 0; i < V; i++) aloc.push(1);
    } else {
      var restos = [], usado = 0;
      for (i = 0; i < V; i++) {
        var exato = sobra * pesos[i] / somaP;
        var chao = Math.floor(exato);
        aloc.push(1 + chao);
        usado += chao;
        restos.push({ i: i, f: exato - chao });
      }
      // Desempate por indice: o resultado nao depende da estabilidade do sort.
      restos.sort(function (a, b) { return (b.f - a.f) || (a.i - b.i); });
      for (i = 0; i < sobra - usado; i++) aloc[restos[i].i]++;
    }

    // A fila: cada variante entra (aloc - 1) vezes -- nunca a unidade do piso.
    var fila = [];
    for (i = 0; i < V; i++) for (var q = 1; q < aloc[i]; q++) fila.push(i);
    for (i = fila.length - 1; i > 0; i--) {
      var jj = Math.floor(rnd() * (i + 1));
      var tmp = fila[i]; fila[i] = fila[jj]; fila[jj] = tmp;
    }

    this._rateios[chave] = { aloc: aloc, fila: fila };
    return this._rateios[chave];
  };

  Contador.prototype.porVariante = function (ids, alvo) {
    if (!ids || !ids.length) return null;
    var pos = -1;
    for (var i = 0; i < ids.length; i++) {
      if (String(ids[i]) === String(alvo)) { pos = i; break; }
    }
    if (pos < 0) return null;

    var r = this.rateio(ids);
    var n = r.aloc[pos];
    var baixas = Math.min(this.inicio - this.valor(), r.fila.length);
    for (i = 0; i < baixas; i++) if (r.fila[i] === pos) n--;
    return n < PISO ? PISO : n;
  };

  /* O RELOGIO E O MESMO PRAZO DO ESTOQUE, nao um segundo cronometro.

     Ele sai do mesmo `t0` e dos mesmos `data-segundos`, entao a barra que
     esvazia e o relogio que corre chegam ao fim juntos -- e e isso que faz o
     bloco ser um so. O arranjo anterior colava aqui a faixa de condicoes da
     loja, cujo relogio e o da virada DIARIA: o estoque acabava em 15 minutos e
     o relogio ao lado dizia sete horas, um desmentindo o outro na mesma caixa.

     Em zero a coluna inteira SOME, em vez de ficar em 00:00. Reiniciar o ciclo
     seria a outra saida, e foi descartada: o estoque subiria na frente de quem
     esta com a pagina aberta.

     `Math.ceil` porque o relogio deve mostrar 15:00 no primeiro instante, nao
     14:59 -- com `floor`, o segundo inicial ja apareceria consumido. */
  Contador.prototype.pintarRelogio = function () {
    if (!this.relogio || !this.colPrazo) return;

    var restante = Math.ceil(this.total - (agora() - this.t0) / 1000);
    if (restante <= 0) {
      this.colPrazo.hidden = true;
      return;
    }

    var m = Math.floor(restante / 60);
    var s = restante % 60;
    var txt = m + ':' + (s < 10 ? '0' + s : s);
    if (txt !== this.ultimoRelogio) {
      this.relogio.textContent = txt;
      this.ultimoRelogio = txt;
    }
    this.colPrazo.hidden = false;
  };

  Contador.prototype.tique = function () {
    var n = this.valor();

    // Rede para `data-inicio` invalido (0 ou negativo). Com piso de 1 a contagem
    // normal nunca chega aqui.
    if (n <= 0) {
      this.el.hidden = true;
      if (this.timer) window.clearInterval(this.timer);
      return;
    }

    if (n !== this.ultimo) {
      var primeiro = this.ultimo === null;
      this.pintar(n, !primeiro, primeiro ? 0 : this.ultimo - n);
      this.ultimo = n;
    }

    /* FORA do `if`: o estoque muda a cada ~20 segundos e o relogio a cada 1.
       Dentro, ele so andaria quando uma peca saisse -- e ficaria parado
       enquanto o resto do bloco diz que o tempo esta correndo. */
    this.pintarRelogio();
  };

  Contador.prototype.iniciar = function () {
    if (this.valor() <= 0) return; // nasce e nao aparece: a contagem ja acabou
    this.montar(this.valor());
    this.tique();
    this.el.hidden = false;
    var self = this;
    this.timer = window.setInterval(function () { self.tique(); }, 1000);

    /* Aba que volta do segundo plano recalcula na hora. Sem isso o valor certo
       so apareceria no proximo tique, e quem volta olhando para o numero veria
       um segundo de informacao velha. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) self.tique();
    });
  };

  /* A PONTE COM O SELETOR DE KIT.

     O seletor e outro script e e ele que sabe qual variante esta escolhida; o
     rateio vive aqui, junto do numero de onde ele sai. Em vez de duplicar a
     matematica la, o contador publica duas funcoes e o seletor pergunta.

     `porVariante` devolve `null` quando nao ha contador na pagina -- e o que
     mantem o seletor inalterado nas paginas de kit que nao sao compre e ganhe:
     sem contador, sem linha, sem CSS, sem listener. */
  var instancias = [];

  window.TpEstoqueOferta = {
    valor: function () {
      return instancias.length ? instancias[0].valor() : null;
    },
    porVariante: function (ids, alvo) {
      return instancias.length ? instancias[0].porVariante(ids, alvo) : null;
    }
  };

  function ligar() {
    var els = document.querySelectorAll('tp-estoque-oferta');
    for (var i = 0; i < els.length; i++) {
      if (els[i].dataset.tpEoLigado) continue;
      els[i].dataset.tpEoLigado = '1';
      var c = new Contador(els[i]);
      instancias.push(c);
      c.iniciar();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ligar);
  } else {
    ligar();
  }
}());
